export default __webpack_public_path__ + "static/media/partner-4.1e1158f2.png";